module.exports = __webpack_public_path__ + "static/media/refresh.2a78cab4.png";